module.exports = __webpack_public_path__ + "assets/img/fd67773c3a2561efb9d850e7b277ad32.png";